export default __webpack_public_path__ + "static/media/2-Cloudxier-Heavenlyblush-website-allproducts.f8f62802.jpg";